import '@/shims'
import '@/lib/datadog'
import { configureAnalytics } from '@shipt/analytics-member-web'

configureAnalytics({
  apiUrl: process.env.NEXT_PUBLIC_SHIPT_ANALYTICS_API_URL,
  writeKey: process.env.NEXT_PUBLIC_SHIPT_ANALYTICS_WRITE_KEY,
})
